import { setNewPassword } from "../../api/set-new-password/index";

export const setNewPasswordService = async (token: string, password: string) => {
  const response = await setNewPassword(token, password);
  return response;
};
